import NotificationConfig from './NotificationConfig';

export default NotificationConfig;
